import React, { useCallback, useEffect, useState } from 'react';

import '@eika/header-style';
import { useViewType, ViewType } from '@eika/hooks';

import DesktopHeader from './DesktopHeader';
import HeaderApp from './HeaderApp';
import { Props } from './HeaderTypes';
import NativeHeader from './NativeHeader';

const Header: React.FC<Props> = ({ logoutUrl, isNative, headerApp, ...rest }) => {
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const viewType = useViewType();

    const headerPosYOffset = 4;
    const handleScroll = useCallback(() => {
        const { scrollY } = window;
        if (viewType !== ViewType.mobile) setScrolled(scrollY > headerPosYOffset);
    }, [viewType]);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [handleScroll]);

    const scrollToTop = () => {
        if (!menuOpen) window.scrollTo(0, 0);
    };

    const onKeyDown = (event: React.KeyboardEvent) => {
        if (event.code === 'Enter') scrollToTop();
    };

    const onMenuOpen = (open: boolean) => {
        setMenuOpen(open);
    };

    const logout = () => {
        if (logoutUrl) window.location.href = logoutUrl;
    };

    return isNative ? (
        <NativeHeader
            scrolled={scrolled}
            scrollToTop={scrollToTop}
            onKeyDown={onKeyDown}
            logout={logout}
            onMenuOpen={onMenuOpen}
            {...rest}
        >
            {headerApp && <HeaderApp {...headerApp} isNative={isNative} frontpage={Boolean(rest.frontpage)} />}
        </NativeHeader>
    ) : (
        <DesktopHeader
            scrolled={scrolled}
            scrollToTop={scrollToTop}
            onKeyDown={onKeyDown}
            logout={logout}
            onMenuOpen={onMenuOpen}
            {...rest}
        >
            {headerApp && <HeaderApp {...headerApp} isNative={Boolean(isNative)} frontpage={Boolean(rest.frontpage)} />}
        </DesktopHeader>
    );
};

export default Header;
